import React from 'react';


export default function Header(props) {
    const { Usuario } = props;

    const Logout = () => {
        window.localStorage.clear();
        window.location = `${process.env.BASEURL}/`;
    }
    const Click = () => {
        //alert('click');
    }
    return (
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

            <a id="sidebarToggleTop" className="btn btn-link rounded-circle mr-3" onClick={() => Click()}>
                <i className="fa fa-bars" style={{ color: "#E6453B" }}></i>
            </a>
            <div style={{ width: "100%", textAlign: 'center' }}>
                {/* <img src={require("../../assets/logo.png")} style={{height:"50px"}} /> */}
                <img src="/assets/img/logo.png"  style={{height:"50px"}} alt="logo_megabola" />
            </div>
            <ul className="navbar-nav ml-auto">
                <div className="topbar-divider d-none d-sm-block"></div>
                <li className="nav-item dropdown no-arrow">
                    <a className="nav-link dropdown-toggle" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="mr-2 d-none d-lg-inline text-gray-600 small">{Usuario.nombre}</span>
                        <img className="img-profile rounded-circle" src="/assets/img/undraw_profile.svg" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown" id="menuout">
                        <a className="dropdown-item" onClick={() => Logout()} style={{ cursor: 'pointer' }}>
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Cerrar sesíon
                        </a>
                    </div>

                </li>

            </ul>

        </nav>
    )
}
